module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/loans-desktop-0fcbe8068c5f6e56bd8f46f0ebca7a23.png";